"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _knotchincWebReactComponentsHelpers = require("@bit/knotchinc.web-react-components.helpers.validator-utils");

var _styled = require("./styled.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
function (_Component) {
  _inherits(Input, _Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));
    _this.state = {
      value: props["default"] || '',
      interacted: false,
      error: null
    };
    return _this;
  }

  _createClass(Input, [{
    key: "onKeyUp",
    value: function onKeyUp(e) {
      var value = e.target.value;
      var _this$props = this.props,
          validate = _this$props.validate,
          callback = _this$props.callback;
      var validation = validate(value);
      callback(value);
      this.setState({
        error: validation.message
      });
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      this.setState({
        value: ''
      });
      this.props.callback(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          hideErrorText = _this$props2.hideErrorText;
      var _this$state = this.state,
          value = _this$state.value,
          error = _this$state.error;
      return _react["default"].createElement(_styled.InputContainer, null, _react["default"].createElement(_styled.StyledInput, {
        value: value,
        onChange: function onChange(e) {
          return _this2.setState({
            value: e.target.value
          });
        },
        onKeyUp: function onKeyUp(e) {
          return _this2.onKeyUp(e);
        },
        placeholder: placeholder
      }), value && _react["default"].createElement(_styled.ClearInput, {
        onClick: function onClick() {
          return _this2.clearInput();
        }
      }, "\u2715"), !hideErrorText && _react["default"].createElement(_styled.StyledInputError, {
        shown: error
      }, error));
    }
  }]);

  return Input;
}(_react.Component);

Input.defaultProps = {
  validate: _knotchincWebReactComponentsHelpers.textValidator,
  hideErrorText: false
};
var _default = Input;
exports["default"] = _default;

//# sourceMappingURL=Input.js.map